module.exports = __webpack_public_path__ + "img/GobiernoChiapas.0ee50a2f.png";